const subscribedmemberscolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "email",
    label: "Email",
  },
  {
    key: "lastLogin",
    label: "Recent log in",
  },
  {
    key: "price",
    label: "Price",
  },
  {
    key: "startDate",
    label: "Start Date",
  },
  {
    key: "endDate",
    label: "End Date",
  },
  {
    key: "subscribeDate",
    label: "Subscribe Date",
  },
  {
    key: "country",
    label: "Country",
  },
  {
    key: "plan",
    label: "Plan",
  },
  {
    key: "orderNo",
    label: "orderNo",
  },
  {
    key: "subscription",
    label: "Status",
  },
  {
    key: "actions",
    label: "Actions",
  },
];

export { subscribedmemberscolumn };
